__turbopack_context__.v({
  "buttonsWrapper": "_mz2Ia_buttonsWrapper",
  "small": "_mz2Ia_small",
});
